import * as React from 'react';
import { CheckboxView, CheckboxViewProps } from './Checkbox.view';
import classNames from 'classnames';
import classes from './Checkbox.module.scss';
import inputClasses from '../form.module.scss';

export type CheckboxControllerProps = Omit<
  CheckboxViewProps,
  'elemWrapperClasses' | 'globalClasses' | 'labelClasses' | 'helperClass' | 'errorClasses' | 'lastLabelFragmentClass'
> & {
  // extend your CheckboxViewProps
};

export const CheckboxController = (props: CheckboxControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const clonedProps: CheckboxControllerProps = { ...props };

  clonedProps.disabled = props.disabled || false;
  clonedProps.helper = props.helper || '';
  clonedProps.readonly = props.readonly || false;
  clonedProps.indeterminate = props.indeterminate || false;

  const {
    formState: { errors }
  } = props.formInstance;

  const globalClasses = classNames(inputClasses.FormInputs, inputClasses[clonedProps.size]);
  const helperClass = classNames(inputClasses.HelpText);
  const errorClasses = classNames(inputClasses.HelpTextErrorClass, inputClasses.HelpText);
  const elemWrapperClasses = classNames(classes.CheckboxWrapper, classes[`CheckboxSize_${props.size}`]);
  const lastLabelFragmentClass = classNames(classes[`CheckboxSize_${props.size}LastLabel`]);
  const labelClasses = classNames({
    [classes.ErrorClass]: !!errors && errors.hasOwnProperty(props.name),
    [classes.Opaque]: !!props.opaque
  });

  const attrs = {
    ...clonedProps,
    elemWrapperClasses,
    errorClasses,
    globalClasses,
    helperClass,
    labelClasses,
    lastLabelFragmentClass
  };

  return <CheckboxView {...attrs} />;
};
